import { jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import analytics from "../analytics/analytics.js";
import { ChatbotDataContext } from "./ChatbotDataContext.js";
let chatRguid = '';
const ChatbotDataProvider = (props)=>{
    const { submitChatMessagesPayload, handleMarkerResponse, fetchRequestOptions, markerComponents, logFirstMessageSubmitted, logCustomerCarePhoneNumberDisplayed, logCustomerCarePhoneNumberClicked, enableVoice, enableVoiceTooltip, quickActions, quickActionsStackVariant, isMobile, setiValues, debugMode, discoveryCitySelected, speechFetchRequestOptions, transcriptionFetchRequestOptions, audioPlayerRef, isRealtime, isDev, setLoadMoreMessages, loadMoreMessages, shouldDisplayGenHotelFeature, componentVersion, requestFrom, retrieveUrl, chatbotFeatures, showLandingPage } = props;
    const { pushPrompt, enabledActions } = submitChatMessagesPayload ?? {};
    const [errorMessage, setErrorMessage] = useState('');
    const [accountLessAccessToken, setAccountLessAccessToken] = useState('');
    const [accountLessTripsAccessPayload, setAccountLessTripsAccessPayload] = useState();
    const [isDisablingInput, setIsDisablingInputValue] = useState(false);
    const [fullStreamingTexts, setStreamingText] = useState('');
    const setAccountLessAccessTokenMemoFn = useMemo(()=>({
            setAccountLessAccessToken
        }), [
        setAccountLessAccessToken
    ]);
    const funcValues = useMemo(()=>({
            setErrorMessage,
            setIsDisablingInputValue,
            setStreamingText,
            setLoadMoreMessages,
            setAccountLessTripsAccessPayload
        }), [
        setErrorMessage,
        setIsDisablingInputValue,
        setStreamingText,
        setLoadMoreMessages,
        setAccountLessTripsAccessPayload
    ]);
    if (chatRguid) submitChatMessagesPayload.rguid = chatRguid;
    else chatRguid = submitChatMessagesPayload.rguid;
    const accountLessAccessTokensContext = {
        accountLessAccessToken,
        ...setAccountLessAccessTokenMemoFn
    };
    const contextValues = {
        isSessionActive: true,
        discoveryCitySelected,
        submitChatMessagesPayload,
        handleMarkerResponse,
        fetchRequestOptions,
        markerComponents,
        logFirstMessageSubmitted,
        logCustomerCarePhoneNumberDisplayed,
        logCustomerCarePhoneNumberClicked,
        quickActions,
        quickActionsStackVariant,
        isMobile,
        isRealtime,
        debugMode,
        isDev,
        loadMoreMessages,
        chatbotFeatures,
        showLandingPage,
        errorMessage,
        isDisablingInput,
        fullStreamingTexts,
        enableVoice,
        enableVoiceTooltip,
        setiValues,
        speechFetchRequestOptions,
        transcriptionFetchRequestOptions,
        pushPrompt,
        audioPlayerRef,
        shouldDisplayGenHotelFeature,
        componentVersion,
        shouldUseMapFeature: enabledActions?.shouldEnableInlineLocationMetadata,
        accountLessTripsAccessPayload,
        requestFrom,
        retrieveUrl,
        ...funcValues
    };
    useEffect(()=>{
        analytics.init(contextValues);
    }, []);
    return /*#__PURE__*/ jsx(ChatbotDataContext.Provider, {
        value: {
            ...contextValues,
            ...accountLessAccessTokensContext
        },
        children: props.children
    });
};
export { ChatbotDataProvider };
